define(function(require) {
    // GEO09E37_SECT_STA layer definition config
    return {
        LAYER_ID: "GEO09E37_SECT_STA",
        LAYER_TYPE: "POLYGON",
        USE_TYPED_ARRAY: true,
        LOADING_MODE: "INITIAL",
        TOKEN_REQUIRED: true,
        INDEX: 6,
        DATATABLE_ID: "t_GEO09E37_SECT_STA",
        QUERY_FIELDS: [
            "SECTEUR", "CD_COULR",
            //from the joined table
            "NOM_SECTEUR", "DT_REALISATION", "NOTES",
            "OBSE_AN0_M4", "PREVA_ANP1_M4", "PREVB_ANP2_M4", "PREVC_ANP3_M4", "PREVD_ANP4_M4", "PREVE_ANP5_M4",
            "OBSE_AN0_M5", "PREVA_ANP1_M5", "PREVB_ANP2_M5", "PREVC_ANP3_M5", "PREVD_ANP4_M5", "PREVE_ANP5_M5",
            "OBSE_AN0_M_TOT", "PREVA_ANP1_M_TOT", "PREVB_ANP2_M_TOT", "PREVC_ANP3_M_TOT", "PREVD_ANP4_M_TOT", "PREVE_ANP5_M_TOT",
            "OBSE_AN0_P_TOT", "PREVA_ANP1_P_TOT", "PREVB_ANP2_P_TOT", "PREVC_ANP3_P_TOT", "PREVD_ANP4_P_TOT", "PREVE_ANP5_P_TOT",
            "OBSE_AN0_P_TOT_M_TOT", "PREVA_ANP1_P_TOT_M_TOT", "PREVB_ANP2_P_TOT_M_TOT", "PREVC_ANP3_P_TOT_M_TOT", "PREVD_ANP4_P_TOT_M_TOT", "PREVE_ANP5_P_TOT_M_TOT",
            "OBSE_AN0_S_TOT", "PREVA_ANP1_S_TOT", "PREVB_ANP2_S_TOT", "PREVC_ANP3_S_TOT", "PREVD_ANP4_S_TOT", "PREVE_ANP5_S_TOT", "PREVF_ANP6_S_TOT", "PREVG_ANP7_S_TOT", "PREVH_ANP8_S_TOT", "PREVI_ANP9_S_TOT", "PREVJ_ANP10_S_TOT",
            "OBSE_AN0_TOTAL", "PREVA_ANP1_TOTAL", "PREVB_ANP2_TOTAL", "PREVC_ANP3_TOTAL", "PREVD_ANP4_TOTAL", "PREVE_ANP5_TOTAL"
        ],
        FIELDS: [
            {ID: "SECTEUR", NAME: "Code", DATA_TYPE: "STRING", VALUE: "{{SECTEUR}}"},
            {ID: "CD_COULR", NAME: "CD_COULR", DATA_TYPE: "STRING", VALUE: "{{CD_COULR}}"},
            //from the joined table
            {ID: "NOM_SECTEUR", NAME: "Nom", DATA_TYPE: "STRING", VALUE: "{{NOM_SECTEUR}}"},
            {ID: "DT_REALISATION", NAME: "Date des prévisions", DATA_TYPE: "STRING", VALUE: "{{DT_REALISATION}}"},
            {ID: "NOTES", NAME: "Notes", DATA_TYPE: "STRING", VALUE: "{{NOTES}}"},
            //Maternelle 4 ans
            {ID: "OBSE_AN0_M4", NAME: "OBSE_AN0_M4", DATA_TYPE: "NUMBER", VALUE: "{{OBSE_AN0_M4}}"},
            {ID: "PREVA_ANP1_M4", NAME: "PREVA_ANP1_M4", DATA_TYPE: "NUMBER", VALUE: "{{PREVA_ANP1_M4}}"},
            {ID: "PREVB_ANP2_M4", NAME: "PREVB_ANP2_M4", DATA_TYPE: "NUMBER", VALUE: "{{PREVB_ANP2_M4}}"},
            {ID: "PREVC_ANP3_M4", NAME: "PREVC_ANP3_M4", DATA_TYPE: "NUMBER", VALUE: "{{PREVC_ANP3_M4}}"},
            {ID: "PREVD_ANP4_M4", NAME: "PREVD_ANP4_M4", DATA_TYPE: "NUMBER", VALUE: "{{PREVD_ANP4_M4}}"},
            {ID: "PREVE_ANP5_M4", NAME: "PREVE_ANP5_M4", DATA_TYPE: "NUMBER", VALUE: "{{PREVE_ANP5_M4}}"},
            //Maternelle 5 ans
            {ID: "OBSE_AN0_M5", NAME: "OBSE_AN0_M5", DATA_TYPE: "NUMBER", VALUE: "{{OBSE_AN0_M5}}"},
            {ID: "PREVA_ANP1_M5", NAME: "PREVA_ANP1_M5", DATA_TYPE: "NUMBER", VALUE: "{{PREVA_ANP1_M5}}"},
            {ID: "PREVB_ANP2_M5", NAME: "PREVB_ANP2_M5", DATA_TYPE: "NUMBER", VALUE: "{{PREVB_ANP2_M5}}"},
            {ID: "PREVC_ANP3_M5", NAME: "PREVC_ANP3_M5", DATA_TYPE: "NUMBER", VALUE: "{{PREVC_ANP3_M5}}"},
            {ID: "PREVD_ANP4_M5", NAME: "PREVD_ANP4_M5", DATA_TYPE: "NUMBER", VALUE: "{{PREVD_ANP4_M5}}"},
            {ID: "PREVE_ANP5_M5", NAME: "PREVE_ANP5_M5", DATA_TYPE: "NUMBER", VALUE: "{{PREVE_ANP5_M5}}"},
            //Maternelle Total
            {ID: "OBSE_AN0_M_TOT", NAME: "OBSE_AN0_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{OBSE_AN0_M_TOT}}"},
            {ID: "PREVA_ANP1_M_TOT", NAME: "PREVA_ANP1_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVA_ANP1_M_TOT}}"},
            {ID: "PREVB_ANP2_M_TOT", NAME: "PREVB_ANP2_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVB_ANP2_M_TOT}}"},
            {ID: "PREVC_ANP3_M_TOT", NAME: "PREVC_ANP3_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVC_ANP3_M_TOT}}"},
            {ID: "PREVD_ANP4_M_TOT", NAME: "PREVD_ANP4_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVD_ANP4_M_TOT}}"},
            {ID: "PREVE_ANP5_M_TOT", NAME: "PREVE_ANP5_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVE_ANP5_M_TOT}}"},
            //Primaire Total
            {ID: "OBSE_AN0_P_TOT", NAME: "OBSE_AN0_P_TOT", DATA_TYPE: "NUMBER", VALUE: "{{OBSE_AN0_P_TOT}}"},
            {ID: "PREVA_ANP1_P_TOT", NAME: "PREVA_ANP1_P_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVA_ANP1_P_TOT}}"},
            {ID: "PREVB_ANP2_P_TOT", NAME: "PREVB_ANP2_P_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVB_ANP2_P_TOT}}"},
            {ID: "PREVC_ANP3_P_TOT", NAME: "PREVC_ANP3_P_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVC_ANP3_P_TOT}}"},
            {ID: "PREVD_ANP4_P_TOT", NAME: "PREVD_ANP4_P_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVD_ANP4_P_TOT}}"},
            {ID: "PREVE_ANP5_P_TOT", NAME: "PREVE_ANP5_P_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVE_ANP5_P_TOT}}"},
            //Préscolaire Total
            {ID: "OBSE_AN0_P_TOT_M_TOT", NAME: "OBSE_AN0_P_TOT_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{OBSE_AN0_P_TOT_M_TOT}}"},
            {ID: "PREVA_ANP1_P_TOT_M_TOT", NAME: "PREVA_ANP1_P_TOT_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVA_ANP1_P_TOT_M_TOT}}"},
            {ID: "PREVB_ANP2_P_TOT_M_TOT", NAME: "PREVB_ANP2_P_TOT_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVB_ANP2_P_TOT_M_TOT}}"},
            {ID: "PREVC_ANP3_P_TOT_M_TOT", NAME: "PREVC_ANP3_P_TOT_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVC_ANP3_P_TOT_M_TOT}}"},
            {ID: "PREVD_ANP4_P_TOT_M_TOT", NAME: "PREVD_ANP4_P_TOT_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVD_ANP4_P_TOT_M_TOT}}"},
            {ID: "PREVE_ANP5_P_TOT_M_TOT", NAME: "PREVE_ANP5_P_TOT_M_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVE_ANP5_P_TOT_M_TOT}}"},
            //Secondaire Total
            {ID: "OBSE_AN0_S_TOT", NAME: "OBSE_AN0_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{OBSE_AN0_S_TOT}}"},
            {ID: "PREVA_ANP1_S_TOT", NAME: "PREVA_ANP1_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVA_ANP1_S_TOT}}"},
            {ID: "PREVB_ANP2_S_TOT", NAME: "PREVB_ANP2_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVB_ANP2_S_TOT}}"},
            {ID: "PREVC_ANP3_S_TOT", NAME: "PREVC_ANP3_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVC_ANP3_S_TOT}}"},
            {ID: "PREVD_ANP4_S_TOT", NAME: "PREVD_ANP4_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVD_ANP4_S_TOT}}"},
            {ID: "PREVE_ANP5_S_TOT", NAME: "PREVE_ANP5_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVE_ANP5_S_TOT}}"},
            {ID: "PREVF_ANP6_S_TOT", NAME: "PREVF_ANP6_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVF_ANP6_S_TOT}}"},
            {ID: "PREVG_ANP7_S_TOT", NAME: "PREVG_ANP7_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVG_ANP7_S_TOT}}"},
            {ID: "PREVH_ANP8_S_TOT", NAME: "PREVH_ANP8_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVH_ANP8_S_TOT}}"},
            {ID: "PREVI_ANP9_S_TOT", NAME: "PREVI_ANP9_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVI_ANP9_S_TOT}}"},
            {ID: "PREVJ_ANP10_S_TOT", NAME: "PREVJ_ANP10_S_TOT", DATA_TYPE: "NUMBER", VALUE: "{{PREVJ_ANP10_S_TOT}}"},
            //Ensemble Total
            {ID: "OBSE_AN0_TOTAL", NAME: "OBSE_AN0_TOTAL", DATA_TYPE: "NUMBER", VALUE: "{{OBSE_AN0_TOTAL}}"},
            {ID: "PREVA_ANP1_TOTAL", NAME: "PREVA_ANP1_TOTAL", DATA_TYPE: "NUMBER", VALUE: "{{PREVA_ANP1_TOTAL}}"},
            {ID: "PREVB_ANP2_TOTAL", NAME: "PREVB_ANP2_TOTAL", DATA_TYPE: "NUMBER", VALUE: "{{PREVB_ANP2_TOTAL}}"},
            {ID: "PREVC_ANP3_TOTAL", NAME: "PREVC_ANP3_TOTAL", DATA_TYPE: "NUMBER", VALUE: "{{PREVC_ANP3_TOTAL}}"},
            {ID: "PREVD_ANP4_TOTAL", NAME: "PREVD_ANP4_TOTAL", DATA_TYPE: "NUMBER", VALUE: "{{PREVD_ANP4_TOTAL}}"},
            {ID: "PREVE_ANP5_TOTAL", NAME: "PREVE_ANP5_TOTAL", DATA_TYPE: "NUMBER", VALUE: "{{PREVE_ANP5_TOTAL}}"},
        ],
        JOIN_KEY: "SECT",
        STYLES: [
            {
                ID: "0",
                VALUE: 0,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "SOLID",
                        FILL_COLOR_1: "rgba(135,119,105,1)",
                        STROKE_COLOR: "rgba(166,166,166,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 1
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(0,0,0,1)",
                    FONT_NAME: "Arimo-Bold",
                    FONT_FILE_SOURCE: "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 12
                }
            }, {
                ID: "1",
                VALUE: 1,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "SOLID",
                        FILL_COLOR_1: "rgba(225,194,116,1)",
                        STROKE_COLOR: "rgba(166,166,166,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 1
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(0,0,0,1)",
                    FONT_NAME: "Arimo-Bold",
                    FONT_FILE_SOURCE: "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 12
                }
            }, {
                ID: "2",
                VALUE: 2,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "SOLID",
                        FILL_COLOR_1: "rgba(59,73,187,1)",
                        STROKE_COLOR: "rgba(166,166,166,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 1
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(0,0,0,1)",
                    FONT_NAME: "Arimo-Bold",
                    FONT_FILE_SOURCE: "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 12
                }
            }, {
                ID: "3",
                VALUE: 3,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "SOLID",
                        FILL_COLOR_1: "rgba(149,208,2,1)",
                        STROKE_COLOR: "rgba(166,166,166,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 1
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(0,0,0,1)",
                    FONT_NAME: "Arimo-Bold",
                    FONT_FILE_SOURCE: "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 12
                }
            }, {
                ID: "4",
                VALUE: 4,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "SOLID",
                        FILL_COLOR_1: "rgba(239,87,79,1)",
                        STROKE_COLOR: "rgba(166,166,166,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 1
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(0,0,0,1)",
                    FONT_NAME: "Arimo-Bold",
                    FONT_FILE_SOURCE: "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 12
                }
            }, {
                ID: "5",
                VALUE: 5,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "SOLID",
                        FILL_COLOR_1: "rgba(73,222,144,1)",
                        STROKE_COLOR: "rgba(166,166,166,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 1
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(0,0,0,1)",
                    FONT_NAME: "Arimo-Bold",
                    FONT_FILE_SOURCE: "app/fonts/externals/Arimo-Bold",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 12
                }
            }
        ],
        LAYER_PROPERTIES: {
            NAME : "Secteurs, édition PPS 2026",
            FEATURE_ID_DATACOLUMN: "SECTEUR",
            FEATURE_NAME_DATACOLUMN: "NOM_SECTEUR",
            DATATIP_DATACOLUMNS: ["SECTEUR", "NOM_SECTEUR"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE: "NONE",
            //DATAVIEW_DATACOLUMNS: ["SECTEUR", "NOM_SECTEUR"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE: "NONE",
            INFOVIEW_DATACOLUMNS: ["SECTEUR", "NOM_SECTEUR"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE: "NONE",
            SHOW_STYLES_IN_LAYER_CONTROL: false,
            IS_VISIBLE_IN_LAYER_CONTROL : true,
            STYLE_DATACOLUMN: "CD_COULR",
            ALPHA: 0.5,
            LABEL_DATACOLUMN: "SECTEUR",
            LABEL_PROPERTIES: {
                ALLOW_LABEL_DUPLICATES: true,
                LEADER_LINES: false,
                POSITION: "MIDDLE-CENTER",
                PRIORITY: 9
            },
            VISIBLE: false
        }
    };
});
